import { render, staticRenderFns } from "./CardLabCheck.vue?vue&type=template&id=6a781562&scoped=true"
import script from "./CardLabCheck.vue?vue&type=script&lang=js"
export * from "./CardLabCheck.vue?vue&type=script&lang=js"
import style0 from "./CardLabCheck.vue?vue&type=style&index=0&id=6a781562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a781562",
  null
  
)

export default component.exports